/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

// Import Routes

import { Route as rootRoute } from './routes/__root'
import { Route as LayoutImport } from './routes/_layout'
import { Route as GetExetelAppIndexImport } from './routes/get-exetel-app/index'
import { Route as LayoutIndexImport } from './routes/_layout.index'
import { Route as AppDownloadImport } from './routes/app/download'
import { Route as LayoutTermsIndexImport } from './routes/_layout.terms/index'
import { Route as LayoutSpeedTestIndexImport } from './routes/_layout.speed-test/index'
import { Route as LayoutSpecialistSupportIndexImport } from './routes/_layout.specialist-support/index'
import { Route as LayoutPrivacyPolicyIndexImport } from './routes/_layout.privacy-policy/index'
import { Route as LayoutNetworkOutageIndexImport } from './routes/_layout.network-outage/index'
import { Route as LayoutMobilephoneIndexImport } from './routes/_layout.mobilephone/index'
import { Route as LayoutLodgeAComplaintIndexImport } from './routes/_layout.lodge-a-complaint/index'
import { Route as LayoutExrayIndexImport } from './routes/_layout.exray/index'
import { Route as LayoutEsafetyIndexImport } from './routes/_layout.esafety/index'
import { Route as LayoutEmailIndexImport } from './routes/_layout.email/index'
import { Route as LayoutDisasterReliefIndexImport } from './routes/_layout.disaster-relief/index'
import { Route as LayoutDemoPageIndexImport } from './routes/_layout.demo-page/index'
import { Route as LayoutContactUsIndexImport } from './routes/_layout.contact-us/index'
import { Route as LayoutBlogIndexImport } from './routes/_layout.blog/index'
import { Route as LayoutAssistanceIndexImport } from './routes/_layout.assistance/index'
import { Route as LayoutAppIndexImport } from './routes/_layout.app/index'
import { Route as LayoutAboutUsIndexImport } from './routes/_layout.about-us/index'
import { Route as LayoutMobilephoneCoverageImport } from './routes/_layout.mobilephone/coverage'
import { Route as LayoutBlogSlugImport } from './routes/_layout.blog/$slug'
import { Route as LayoutBroadbandWarpSpeedIndexImport } from './routes/_layout.broadband/warp-speed/index'
import { Route as LayoutBroadbandReferAFriendIndexImport } from './routes/_layout.broadband/refer-a-friend/index'
import { Route as LayoutBroadbandNbnIndexImport } from './routes/_layout.broadband/nbn/index'
import { Route as LayoutBroadbandHibernateIndexImport } from './routes/_layout.broadband/hibernate/index'
import { Route as LayoutBroadbandHfcIndexImport } from './routes/_layout.broadband/hfc/index'
import { Route as LayoutBroadbandFttpIndexImport } from './routes/_layout.broadband/fttp/index'
import { Route as LayoutBroadbandAboutSpeedsIndexImport } from './routes/_layout.broadband/about-speeds/index'

// Create/Update Routes

const LayoutRoute = LayoutImport.update({
  id: '/_layout',
  getParentRoute: () => rootRoute,
} as any)

const GetExetelAppIndexRoute = GetExetelAppIndexImport.update({
  id: '/get-exetel-app/',
  path: '/get-exetel-app/',
  getParentRoute: () => rootRoute,
} as any)

const LayoutIndexRoute = LayoutIndexImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => LayoutRoute,
} as any)

const AppDownloadRoute = AppDownloadImport.update({
  id: '/app/download',
  path: '/app/download',
  getParentRoute: () => rootRoute,
} as any)

const LayoutTermsIndexRoute = LayoutTermsIndexImport.update({
  id: '/terms/',
  path: '/terms/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSpeedTestIndexRoute = LayoutSpeedTestIndexImport.update({
  id: '/speed-test/',
  path: '/speed-test/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutSpecialistSupportIndexRoute =
  LayoutSpecialistSupportIndexImport.update({
    id: '/specialist-support/',
    path: '/specialist-support/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutPrivacyPolicyIndexRoute = LayoutPrivacyPolicyIndexImport.update({
  id: '/privacy-policy/',
  path: '/privacy-policy/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutNetworkOutageIndexRoute = LayoutNetworkOutageIndexImport.update({
  id: '/network-outage/',
  path: '/network-outage/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMobilephoneIndexRoute = LayoutMobilephoneIndexImport.update({
  id: '/mobilephone/',
  path: '/mobilephone/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutLodgeAComplaintIndexRoute = LayoutLodgeAComplaintIndexImport.update(
  {
    id: '/lodge-a-complaint/',
    path: '/lodge-a-complaint/',
    getParentRoute: () => LayoutRoute,
  } as any,
)

const LayoutExrayIndexRoute = LayoutExrayIndexImport.update({
  id: '/exray/',
  path: '/exray/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEsafetyIndexRoute = LayoutEsafetyIndexImport.update({
  id: '/esafety/',
  path: '/esafety/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutEmailIndexRoute = LayoutEmailIndexImport.update({
  id: '/email/',
  path: '/email/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDisasterReliefIndexRoute = LayoutDisasterReliefIndexImport.update({
  id: '/disaster-relief/',
  path: '/disaster-relief/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutDemoPageIndexRoute = LayoutDemoPageIndexImport.update({
  id: '/demo-page/',
  path: '/demo-page/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutContactUsIndexRoute = LayoutContactUsIndexImport.update({
  id: '/contact-us/',
  path: '/contact-us/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutBlogIndexRoute = LayoutBlogIndexImport.update({
  id: '/blog/',
  path: '/blog/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAssistanceIndexRoute = LayoutAssistanceIndexImport.update({
  id: '/assistance/',
  path: '/assistance/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAppIndexRoute = LayoutAppIndexImport.update({
  id: '/app/',
  path: '/app/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutAboutUsIndexRoute = LayoutAboutUsIndexImport.update({
  id: '/about-us/',
  path: '/about-us/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutMobilephoneCoverageRoute = LayoutMobilephoneCoverageImport.update({
  id: '/mobilephone/coverage',
  path: '/mobilephone/coverage',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutBlogSlugRoute = LayoutBlogSlugImport.update({
  id: '/blog/$slug',
  path: '/blog/$slug',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutBroadbandWarpSpeedIndexRoute =
  LayoutBroadbandWarpSpeedIndexImport.update({
    id: '/broadband/warp-speed/',
    path: '/broadband/warp-speed/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutBroadbandReferAFriendIndexRoute =
  LayoutBroadbandReferAFriendIndexImport.update({
    id: '/broadband/refer-a-friend/',
    path: '/broadband/refer-a-friend/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutBroadbandNbnIndexRoute = LayoutBroadbandNbnIndexImport.update({
  id: '/broadband/nbn/',
  path: '/broadband/nbn/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutBroadbandHibernateIndexRoute =
  LayoutBroadbandHibernateIndexImport.update({
    id: '/broadband/hibernate/',
    path: '/broadband/hibernate/',
    getParentRoute: () => LayoutRoute,
  } as any)

const LayoutBroadbandHfcIndexRoute = LayoutBroadbandHfcIndexImport.update({
  id: '/broadband/hfc/',
  path: '/broadband/hfc/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutBroadbandFttpIndexRoute = LayoutBroadbandFttpIndexImport.update({
  id: '/broadband/fttp/',
  path: '/broadband/fttp/',
  getParentRoute: () => LayoutRoute,
} as any)

const LayoutBroadbandAboutSpeedsIndexRoute =
  LayoutBroadbandAboutSpeedsIndexImport.update({
    id: '/broadband/about-speeds/',
    path: '/broadband/about-speeds/',
    getParentRoute: () => LayoutRoute,
  } as any)

// Populate the FileRoutesByPath interface

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_layout': {
      id: '/_layout'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof LayoutImport
      parentRoute: typeof rootRoute
    }
    '/app/download': {
      id: '/app/download'
      path: '/app/download'
      fullPath: '/app/download'
      preLoaderRoute: typeof AppDownloadImport
      parentRoute: typeof rootRoute
    }
    '/_layout/': {
      id: '/_layout/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof LayoutIndexImport
      parentRoute: typeof LayoutImport
    }
    '/get-exetel-app/': {
      id: '/get-exetel-app/'
      path: '/get-exetel-app'
      fullPath: '/get-exetel-app'
      preLoaderRoute: typeof GetExetelAppIndexImport
      parentRoute: typeof rootRoute
    }
    '/_layout/blog/$slug': {
      id: '/_layout/blog/$slug'
      path: '/blog/$slug'
      fullPath: '/blog/$slug'
      preLoaderRoute: typeof LayoutBlogSlugImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/mobilephone/coverage': {
      id: '/_layout/mobilephone/coverage'
      path: '/mobilephone/coverage'
      fullPath: '/mobilephone/coverage'
      preLoaderRoute: typeof LayoutMobilephoneCoverageImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/about-us/': {
      id: '/_layout/about-us/'
      path: '/about-us'
      fullPath: '/about-us'
      preLoaderRoute: typeof LayoutAboutUsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/app/': {
      id: '/_layout/app/'
      path: '/app'
      fullPath: '/app'
      preLoaderRoute: typeof LayoutAppIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/assistance/': {
      id: '/_layout/assistance/'
      path: '/assistance'
      fullPath: '/assistance'
      preLoaderRoute: typeof LayoutAssistanceIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/blog/': {
      id: '/_layout/blog/'
      path: '/blog'
      fullPath: '/blog'
      preLoaderRoute: typeof LayoutBlogIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/contact-us/': {
      id: '/_layout/contact-us/'
      path: '/contact-us'
      fullPath: '/contact-us'
      preLoaderRoute: typeof LayoutContactUsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/demo-page/': {
      id: '/_layout/demo-page/'
      path: '/demo-page'
      fullPath: '/demo-page'
      preLoaderRoute: typeof LayoutDemoPageIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/disaster-relief/': {
      id: '/_layout/disaster-relief/'
      path: '/disaster-relief'
      fullPath: '/disaster-relief'
      preLoaderRoute: typeof LayoutDisasterReliefIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/email/': {
      id: '/_layout/email/'
      path: '/email'
      fullPath: '/email'
      preLoaderRoute: typeof LayoutEmailIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/esafety/': {
      id: '/_layout/esafety/'
      path: '/esafety'
      fullPath: '/esafety'
      preLoaderRoute: typeof LayoutEsafetyIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/exray/': {
      id: '/_layout/exray/'
      path: '/exray'
      fullPath: '/exray'
      preLoaderRoute: typeof LayoutExrayIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/lodge-a-complaint/': {
      id: '/_layout/lodge-a-complaint/'
      path: '/lodge-a-complaint'
      fullPath: '/lodge-a-complaint'
      preLoaderRoute: typeof LayoutLodgeAComplaintIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/mobilephone/': {
      id: '/_layout/mobilephone/'
      path: '/mobilephone'
      fullPath: '/mobilephone'
      preLoaderRoute: typeof LayoutMobilephoneIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/network-outage/': {
      id: '/_layout/network-outage/'
      path: '/network-outage'
      fullPath: '/network-outage'
      preLoaderRoute: typeof LayoutNetworkOutageIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/privacy-policy/': {
      id: '/_layout/privacy-policy/'
      path: '/privacy-policy'
      fullPath: '/privacy-policy'
      preLoaderRoute: typeof LayoutPrivacyPolicyIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/specialist-support/': {
      id: '/_layout/specialist-support/'
      path: '/specialist-support'
      fullPath: '/specialist-support'
      preLoaderRoute: typeof LayoutSpecialistSupportIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/speed-test/': {
      id: '/_layout/speed-test/'
      path: '/speed-test'
      fullPath: '/speed-test'
      preLoaderRoute: typeof LayoutSpeedTestIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/terms/': {
      id: '/_layout/terms/'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof LayoutTermsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/broadband/about-speeds/': {
      id: '/_layout/broadband/about-speeds/'
      path: '/broadband/about-speeds'
      fullPath: '/broadband/about-speeds'
      preLoaderRoute: typeof LayoutBroadbandAboutSpeedsIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/broadband/fttp/': {
      id: '/_layout/broadband/fttp/'
      path: '/broadband/fttp'
      fullPath: '/broadband/fttp'
      preLoaderRoute: typeof LayoutBroadbandFttpIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/broadband/hfc/': {
      id: '/_layout/broadband/hfc/'
      path: '/broadband/hfc'
      fullPath: '/broadband/hfc'
      preLoaderRoute: typeof LayoutBroadbandHfcIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/broadband/hibernate/': {
      id: '/_layout/broadband/hibernate/'
      path: '/broadband/hibernate'
      fullPath: '/broadband/hibernate'
      preLoaderRoute: typeof LayoutBroadbandHibernateIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/broadband/nbn/': {
      id: '/_layout/broadband/nbn/'
      path: '/broadband/nbn'
      fullPath: '/broadband/nbn'
      preLoaderRoute: typeof LayoutBroadbandNbnIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/broadband/refer-a-friend/': {
      id: '/_layout/broadband/refer-a-friend/'
      path: '/broadband/refer-a-friend'
      fullPath: '/broadband/refer-a-friend'
      preLoaderRoute: typeof LayoutBroadbandReferAFriendIndexImport
      parentRoute: typeof LayoutImport
    }
    '/_layout/broadband/warp-speed/': {
      id: '/_layout/broadband/warp-speed/'
      path: '/broadband/warp-speed'
      fullPath: '/broadband/warp-speed'
      preLoaderRoute: typeof LayoutBroadbandWarpSpeedIndexImport
      parentRoute: typeof LayoutImport
    }
  }
}

// Create and export the route tree

interface LayoutRouteChildren {
  LayoutIndexRoute: typeof LayoutIndexRoute
  LayoutBlogSlugRoute: typeof LayoutBlogSlugRoute
  LayoutMobilephoneCoverageRoute: typeof LayoutMobilephoneCoverageRoute
  LayoutAboutUsIndexRoute: typeof LayoutAboutUsIndexRoute
  LayoutAppIndexRoute: typeof LayoutAppIndexRoute
  LayoutAssistanceIndexRoute: typeof LayoutAssistanceIndexRoute
  LayoutBlogIndexRoute: typeof LayoutBlogIndexRoute
  LayoutContactUsIndexRoute: typeof LayoutContactUsIndexRoute
  LayoutDemoPageIndexRoute: typeof LayoutDemoPageIndexRoute
  LayoutDisasterReliefIndexRoute: typeof LayoutDisasterReliefIndexRoute
  LayoutEmailIndexRoute: typeof LayoutEmailIndexRoute
  LayoutEsafetyIndexRoute: typeof LayoutEsafetyIndexRoute
  LayoutExrayIndexRoute: typeof LayoutExrayIndexRoute
  LayoutLodgeAComplaintIndexRoute: typeof LayoutLodgeAComplaintIndexRoute
  LayoutMobilephoneIndexRoute: typeof LayoutMobilephoneIndexRoute
  LayoutNetworkOutageIndexRoute: typeof LayoutNetworkOutageIndexRoute
  LayoutPrivacyPolicyIndexRoute: typeof LayoutPrivacyPolicyIndexRoute
  LayoutSpecialistSupportIndexRoute: typeof LayoutSpecialistSupportIndexRoute
  LayoutSpeedTestIndexRoute: typeof LayoutSpeedTestIndexRoute
  LayoutTermsIndexRoute: typeof LayoutTermsIndexRoute
  LayoutBroadbandAboutSpeedsIndexRoute: typeof LayoutBroadbandAboutSpeedsIndexRoute
  LayoutBroadbandFttpIndexRoute: typeof LayoutBroadbandFttpIndexRoute
  LayoutBroadbandHfcIndexRoute: typeof LayoutBroadbandHfcIndexRoute
  LayoutBroadbandHibernateIndexRoute: typeof LayoutBroadbandHibernateIndexRoute
  LayoutBroadbandNbnIndexRoute: typeof LayoutBroadbandNbnIndexRoute
  LayoutBroadbandReferAFriendIndexRoute: typeof LayoutBroadbandReferAFriendIndexRoute
  LayoutBroadbandWarpSpeedIndexRoute: typeof LayoutBroadbandWarpSpeedIndexRoute
}

const LayoutRouteChildren: LayoutRouteChildren = {
  LayoutIndexRoute: LayoutIndexRoute,
  LayoutBlogSlugRoute: LayoutBlogSlugRoute,
  LayoutMobilephoneCoverageRoute: LayoutMobilephoneCoverageRoute,
  LayoutAboutUsIndexRoute: LayoutAboutUsIndexRoute,
  LayoutAppIndexRoute: LayoutAppIndexRoute,
  LayoutAssistanceIndexRoute: LayoutAssistanceIndexRoute,
  LayoutBlogIndexRoute: LayoutBlogIndexRoute,
  LayoutContactUsIndexRoute: LayoutContactUsIndexRoute,
  LayoutDemoPageIndexRoute: LayoutDemoPageIndexRoute,
  LayoutDisasterReliefIndexRoute: LayoutDisasterReliefIndexRoute,
  LayoutEmailIndexRoute: LayoutEmailIndexRoute,
  LayoutEsafetyIndexRoute: LayoutEsafetyIndexRoute,
  LayoutExrayIndexRoute: LayoutExrayIndexRoute,
  LayoutLodgeAComplaintIndexRoute: LayoutLodgeAComplaintIndexRoute,
  LayoutMobilephoneIndexRoute: LayoutMobilephoneIndexRoute,
  LayoutNetworkOutageIndexRoute: LayoutNetworkOutageIndexRoute,
  LayoutPrivacyPolicyIndexRoute: LayoutPrivacyPolicyIndexRoute,
  LayoutSpecialistSupportIndexRoute: LayoutSpecialistSupportIndexRoute,
  LayoutSpeedTestIndexRoute: LayoutSpeedTestIndexRoute,
  LayoutTermsIndexRoute: LayoutTermsIndexRoute,
  LayoutBroadbandAboutSpeedsIndexRoute: LayoutBroadbandAboutSpeedsIndexRoute,
  LayoutBroadbandFttpIndexRoute: LayoutBroadbandFttpIndexRoute,
  LayoutBroadbandHfcIndexRoute: LayoutBroadbandHfcIndexRoute,
  LayoutBroadbandHibernateIndexRoute: LayoutBroadbandHibernateIndexRoute,
  LayoutBroadbandNbnIndexRoute: LayoutBroadbandNbnIndexRoute,
  LayoutBroadbandReferAFriendIndexRoute: LayoutBroadbandReferAFriendIndexRoute,
  LayoutBroadbandWarpSpeedIndexRoute: LayoutBroadbandWarpSpeedIndexRoute,
}

const LayoutRouteWithChildren =
  LayoutRoute._addFileChildren(LayoutRouteChildren)

export interface FileRoutesByFullPath {
  '': typeof LayoutRouteWithChildren
  '/app/download': typeof AppDownloadRoute
  '/': typeof LayoutIndexRoute
  '/get-exetel-app': typeof GetExetelAppIndexRoute
  '/blog/$slug': typeof LayoutBlogSlugRoute
  '/mobilephone/coverage': typeof LayoutMobilephoneCoverageRoute
  '/about-us': typeof LayoutAboutUsIndexRoute
  '/app': typeof LayoutAppIndexRoute
  '/assistance': typeof LayoutAssistanceIndexRoute
  '/blog': typeof LayoutBlogIndexRoute
  '/contact-us': typeof LayoutContactUsIndexRoute
  '/demo-page': typeof LayoutDemoPageIndexRoute
  '/disaster-relief': typeof LayoutDisasterReliefIndexRoute
  '/email': typeof LayoutEmailIndexRoute
  '/esafety': typeof LayoutEsafetyIndexRoute
  '/exray': typeof LayoutExrayIndexRoute
  '/lodge-a-complaint': typeof LayoutLodgeAComplaintIndexRoute
  '/mobilephone': typeof LayoutMobilephoneIndexRoute
  '/network-outage': typeof LayoutNetworkOutageIndexRoute
  '/privacy-policy': typeof LayoutPrivacyPolicyIndexRoute
  '/specialist-support': typeof LayoutSpecialistSupportIndexRoute
  '/speed-test': typeof LayoutSpeedTestIndexRoute
  '/terms': typeof LayoutTermsIndexRoute
  '/broadband/about-speeds': typeof LayoutBroadbandAboutSpeedsIndexRoute
  '/broadband/fttp': typeof LayoutBroadbandFttpIndexRoute
  '/broadband/hfc': typeof LayoutBroadbandHfcIndexRoute
  '/broadband/hibernate': typeof LayoutBroadbandHibernateIndexRoute
  '/broadband/nbn': typeof LayoutBroadbandNbnIndexRoute
  '/broadband/refer-a-friend': typeof LayoutBroadbandReferAFriendIndexRoute
  '/broadband/warp-speed': typeof LayoutBroadbandWarpSpeedIndexRoute
}

export interface FileRoutesByTo {
  '/app/download': typeof AppDownloadRoute
  '/': typeof LayoutIndexRoute
  '/get-exetel-app': typeof GetExetelAppIndexRoute
  '/blog/$slug': typeof LayoutBlogSlugRoute
  '/mobilephone/coverage': typeof LayoutMobilephoneCoverageRoute
  '/about-us': typeof LayoutAboutUsIndexRoute
  '/app': typeof LayoutAppIndexRoute
  '/assistance': typeof LayoutAssistanceIndexRoute
  '/blog': typeof LayoutBlogIndexRoute
  '/contact-us': typeof LayoutContactUsIndexRoute
  '/demo-page': typeof LayoutDemoPageIndexRoute
  '/disaster-relief': typeof LayoutDisasterReliefIndexRoute
  '/email': typeof LayoutEmailIndexRoute
  '/esafety': typeof LayoutEsafetyIndexRoute
  '/exray': typeof LayoutExrayIndexRoute
  '/lodge-a-complaint': typeof LayoutLodgeAComplaintIndexRoute
  '/mobilephone': typeof LayoutMobilephoneIndexRoute
  '/network-outage': typeof LayoutNetworkOutageIndexRoute
  '/privacy-policy': typeof LayoutPrivacyPolicyIndexRoute
  '/specialist-support': typeof LayoutSpecialistSupportIndexRoute
  '/speed-test': typeof LayoutSpeedTestIndexRoute
  '/terms': typeof LayoutTermsIndexRoute
  '/broadband/about-speeds': typeof LayoutBroadbandAboutSpeedsIndexRoute
  '/broadband/fttp': typeof LayoutBroadbandFttpIndexRoute
  '/broadband/hfc': typeof LayoutBroadbandHfcIndexRoute
  '/broadband/hibernate': typeof LayoutBroadbandHibernateIndexRoute
  '/broadband/nbn': typeof LayoutBroadbandNbnIndexRoute
  '/broadband/refer-a-friend': typeof LayoutBroadbandReferAFriendIndexRoute
  '/broadband/warp-speed': typeof LayoutBroadbandWarpSpeedIndexRoute
}

export interface FileRoutesById {
  __root__: typeof rootRoute
  '/_layout': typeof LayoutRouteWithChildren
  '/app/download': typeof AppDownloadRoute
  '/_layout/': typeof LayoutIndexRoute
  '/get-exetel-app/': typeof GetExetelAppIndexRoute
  '/_layout/blog/$slug': typeof LayoutBlogSlugRoute
  '/_layout/mobilephone/coverage': typeof LayoutMobilephoneCoverageRoute
  '/_layout/about-us/': typeof LayoutAboutUsIndexRoute
  '/_layout/app/': typeof LayoutAppIndexRoute
  '/_layout/assistance/': typeof LayoutAssistanceIndexRoute
  '/_layout/blog/': typeof LayoutBlogIndexRoute
  '/_layout/contact-us/': typeof LayoutContactUsIndexRoute
  '/_layout/demo-page/': typeof LayoutDemoPageIndexRoute
  '/_layout/disaster-relief/': typeof LayoutDisasterReliefIndexRoute
  '/_layout/email/': typeof LayoutEmailIndexRoute
  '/_layout/esafety/': typeof LayoutEsafetyIndexRoute
  '/_layout/exray/': typeof LayoutExrayIndexRoute
  '/_layout/lodge-a-complaint/': typeof LayoutLodgeAComplaintIndexRoute
  '/_layout/mobilephone/': typeof LayoutMobilephoneIndexRoute
  '/_layout/network-outage/': typeof LayoutNetworkOutageIndexRoute
  '/_layout/privacy-policy/': typeof LayoutPrivacyPolicyIndexRoute
  '/_layout/specialist-support/': typeof LayoutSpecialistSupportIndexRoute
  '/_layout/speed-test/': typeof LayoutSpeedTestIndexRoute
  '/_layout/terms/': typeof LayoutTermsIndexRoute
  '/_layout/broadband/about-speeds/': typeof LayoutBroadbandAboutSpeedsIndexRoute
  '/_layout/broadband/fttp/': typeof LayoutBroadbandFttpIndexRoute
  '/_layout/broadband/hfc/': typeof LayoutBroadbandHfcIndexRoute
  '/_layout/broadband/hibernate/': typeof LayoutBroadbandHibernateIndexRoute
  '/_layout/broadband/nbn/': typeof LayoutBroadbandNbnIndexRoute
  '/_layout/broadband/refer-a-friend/': typeof LayoutBroadbandReferAFriendIndexRoute
  '/_layout/broadband/warp-speed/': typeof LayoutBroadbandWarpSpeedIndexRoute
}

export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | ''
    | '/app/download'
    | '/'
    | '/get-exetel-app'
    | '/blog/$slug'
    | '/mobilephone/coverage'
    | '/about-us'
    | '/app'
    | '/assistance'
    | '/blog'
    | '/contact-us'
    | '/demo-page'
    | '/disaster-relief'
    | '/email'
    | '/esafety'
    | '/exray'
    | '/lodge-a-complaint'
    | '/mobilephone'
    | '/network-outage'
    | '/privacy-policy'
    | '/specialist-support'
    | '/speed-test'
    | '/terms'
    | '/broadband/about-speeds'
    | '/broadband/fttp'
    | '/broadband/hfc'
    | '/broadband/hibernate'
    | '/broadband/nbn'
    | '/broadband/refer-a-friend'
    | '/broadband/warp-speed'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/app/download'
    | '/'
    | '/get-exetel-app'
    | '/blog/$slug'
    | '/mobilephone/coverage'
    | '/about-us'
    | '/app'
    | '/assistance'
    | '/blog'
    | '/contact-us'
    | '/demo-page'
    | '/disaster-relief'
    | '/email'
    | '/esafety'
    | '/exray'
    | '/lodge-a-complaint'
    | '/mobilephone'
    | '/network-outage'
    | '/privacy-policy'
    | '/specialist-support'
    | '/speed-test'
    | '/terms'
    | '/broadband/about-speeds'
    | '/broadband/fttp'
    | '/broadband/hfc'
    | '/broadband/hibernate'
    | '/broadband/nbn'
    | '/broadband/refer-a-friend'
    | '/broadband/warp-speed'
  id:
    | '__root__'
    | '/_layout'
    | '/app/download'
    | '/_layout/'
    | '/get-exetel-app/'
    | '/_layout/blog/$slug'
    | '/_layout/mobilephone/coverage'
    | '/_layout/about-us/'
    | '/_layout/app/'
    | '/_layout/assistance/'
    | '/_layout/blog/'
    | '/_layout/contact-us/'
    | '/_layout/demo-page/'
    | '/_layout/disaster-relief/'
    | '/_layout/email/'
    | '/_layout/esafety/'
    | '/_layout/exray/'
    | '/_layout/lodge-a-complaint/'
    | '/_layout/mobilephone/'
    | '/_layout/network-outage/'
    | '/_layout/privacy-policy/'
    | '/_layout/specialist-support/'
    | '/_layout/speed-test/'
    | '/_layout/terms/'
    | '/_layout/broadband/about-speeds/'
    | '/_layout/broadband/fttp/'
    | '/_layout/broadband/hfc/'
    | '/_layout/broadband/hibernate/'
    | '/_layout/broadband/nbn/'
    | '/_layout/broadband/refer-a-friend/'
    | '/_layout/broadband/warp-speed/'
  fileRoutesById: FileRoutesById
}

export interface RootRouteChildren {
  LayoutRoute: typeof LayoutRouteWithChildren
  AppDownloadRoute: typeof AppDownloadRoute
  GetExetelAppIndexRoute: typeof GetExetelAppIndexRoute
}

const rootRouteChildren: RootRouteChildren = {
  LayoutRoute: LayoutRouteWithChildren,
  AppDownloadRoute: AppDownloadRoute,
  GetExetelAppIndexRoute: GetExetelAppIndexRoute,
}

export const routeTree = rootRoute
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

/* ROUTE_MANIFEST_START
{
  "routes": {
    "__root__": {
      "filePath": "__root.tsx",
      "children": [
        "/_layout",
        "/app/download",
        "/get-exetel-app/"
      ]
    },
    "/_layout": {
      "filePath": "_layout.tsx",
      "children": [
        "/_layout/",
        "/_layout/blog/$slug",
        "/_layout/mobilephone/coverage",
        "/_layout/about-us/",
        "/_layout/app/",
        "/_layout/assistance/",
        "/_layout/blog/",
        "/_layout/contact-us/",
        "/_layout/demo-page/",
        "/_layout/disaster-relief/",
        "/_layout/email/",
        "/_layout/esafety/",
        "/_layout/exray/",
        "/_layout/lodge-a-complaint/",
        "/_layout/mobilephone/",
        "/_layout/network-outage/",
        "/_layout/privacy-policy/",
        "/_layout/specialist-support/",
        "/_layout/speed-test/",
        "/_layout/terms/",
        "/_layout/broadband/about-speeds/",
        "/_layout/broadband/fttp/",
        "/_layout/broadband/hfc/",
        "/_layout/broadband/hibernate/",
        "/_layout/broadband/nbn/",
        "/_layout/broadband/refer-a-friend/",
        "/_layout/broadband/warp-speed/"
      ]
    },
    "/app/download": {
      "filePath": "app/download.tsx"
    },
    "/_layout/": {
      "filePath": "_layout.index.tsx",
      "parent": "/_layout"
    },
    "/get-exetel-app/": {
      "filePath": "get-exetel-app/index.tsx"
    },
    "/_layout/blog/$slug": {
      "filePath": "_layout.blog/$slug.tsx",
      "parent": "/_layout"
    },
    "/_layout/mobilephone/coverage": {
      "filePath": "_layout.mobilephone/coverage.tsx",
      "parent": "/_layout"
    },
    "/_layout/about-us/": {
      "filePath": "_layout.about-us/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/app/": {
      "filePath": "_layout.app/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/assistance/": {
      "filePath": "_layout.assistance/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/blog/": {
      "filePath": "_layout.blog/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/contact-us/": {
      "filePath": "_layout.contact-us/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/demo-page/": {
      "filePath": "_layout.demo-page/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/disaster-relief/": {
      "filePath": "_layout.disaster-relief/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/email/": {
      "filePath": "_layout.email/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/esafety/": {
      "filePath": "_layout.esafety/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/exray/": {
      "filePath": "_layout.exray/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/lodge-a-complaint/": {
      "filePath": "_layout.lodge-a-complaint/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/mobilephone/": {
      "filePath": "_layout.mobilephone/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/network-outage/": {
      "filePath": "_layout.network-outage/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/privacy-policy/": {
      "filePath": "_layout.privacy-policy/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/specialist-support/": {
      "filePath": "_layout.specialist-support/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/speed-test/": {
      "filePath": "_layout.speed-test/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/terms/": {
      "filePath": "_layout.terms/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/broadband/about-speeds/": {
      "filePath": "_layout.broadband/about-speeds/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/broadband/fttp/": {
      "filePath": "_layout.broadband/fttp/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/broadband/hfc/": {
      "filePath": "_layout.broadband/hfc/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/broadband/hibernate/": {
      "filePath": "_layout.broadband/hibernate/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/broadband/nbn/": {
      "filePath": "_layout.broadband/nbn/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/broadband/refer-a-friend/": {
      "filePath": "_layout.broadband/refer-a-friend/index.tsx",
      "parent": "/_layout"
    },
    "/_layout/broadband/warp-speed/": {
      "filePath": "_layout.broadband/warp-speed/index.tsx",
      "parent": "/_layout"
    }
  }
}
ROUTE_MANIFEST_END */
